import { useEffect, useState } from "react";
import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay";
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal";
import { useToast } from "../../contexts/ToastContext";
import { useModal } from "../../contexts/ModalContext";
import { formatValorMoney } from "../../Funcoes/FormatValorMoney";
import SmallLoading from "../../Componentes/Utils/SmallLoading";
import { useParams } from "react-router-dom";
import useApi from "../../hooks/useApi";

const ModalAddFolga = ({ info, fetchData }) => {

    const { matricula } = useParams();

    const { notifySuccess, notifyError } = useToast();
    const { closeModal } = useModal();

    const api = useApi();

    const [loading, setLoading] = useState(true);
    const [formValues, setFormValues] = useState({});

    const [selectedDate, setSelectedDate] = useState('')

    const fetchInfo = async () => {

        setLoading(true);

        try {

            const { data } = await api.post('/Painel/API/Colaborador/GetDistance/', {
                "centro_custo": info.CENTRO_CUSTO,
                "municipio": info.MUNICIPIO,
                "estado": info.ESTADO
            })

            console.log(data);
            setFormValues(data);

        } catch (e) {

            console.log(e);
            notifyError(e?.response?.data?.message || "Não foi possível carregar os dados da folga.");
            closeModal();

        } finally {

            setLoading(false)

        }

    }

    useEffect(() => {

        fetchInfo();

    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            const payload = { ...formValues }
            payload.matricula = matricula
            payload.data = selectedDate

            await api.post('/Painel/API/Colaborador/SaveNewFolga/', payload)

            await fetchData();
            notifySuccess("Folga de campo adicionada com sucesso.");
            closeModal();

        } catch (e) {

            console.log(e);
            const msg = e?.response?.data?.message || "Erro ao salvar folga de campo!";
            notifyError(msg);

        } finally {

            setLoading(false);

        }
    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="md" header={true} close={closeModal} >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="VALOR"
                            type="text"
                            valor={formatValorMoney(formValues.valor)}
                            readOnly
                        />
                        <FormComp
                            title="DIAS GOZO"
                            type="text"
                            valor={formValues.gozo_dias}
                            readOnly
                        />
                        <FormComp
                            title="DATA"
                            type="date"
                            valor={selectedDate}
                            changeFunc={(e) => setSelectedDate(e.target.value)}
                        />
                        <FormComp
                            type="submit"
                            valor="SALVAR"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
            {loading && (
                <Overlay state={true} >
                    <Modal>
                        <SmallLoading />
                    </Modal>
                </Overlay>
            )}
        </>
    )
}

export default ModalAddFolga;